import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as BiIcons from 'react-icons/bi'
import * as MdIcons from 'react-icons/md'

export const SidebarData = [
    {
        title: 'Inicio',
        path: '/',
        icon: <FaIcons.FaHome />,
        private: false,
    },
    {
        title: 'Inicio',
        path: '/',
        icon: <FaIcons.FaHome />,
        private: true,
    },
    {
        title: 'Iniciar sesión',
        path: '/login',
        icon: <FaIcons.FaUserCircle />,
        private: false,
    },
    {
        title: 'Registrate',
        path: '/registrarse',
        icon: <FaIcons.FaUserPlus />,
        private: false,
    },
    {
        title: 'Mi Album',
        path: '/album',
        icon: <BiIcons.BiSolidPhotoAlbum />,
        private: true,
    },
    {
        title: 'Trivia',
        path: '/trivia',
        icon: <MdIcons.MdOutlineQuestionAnswer />,
        private: true,
    },
 /*    {
        title: 'Fichas',
        path: '/fichas',
        icon: <FaIcons.FaFileInvoice />
    },*/
    {
        title: 'Sobre el proyecto',
        path: '/proyecto',
        icon: <FaIcons.FaInfoCircle />,
        private: true,
    },
    {
        title: 'Sobre el proyecto',
        path: '/proyecto',
        icon: <FaIcons.FaInfoCircle />,
        private: false,
    },
    {
        title: 'Cerrar sesión',
        path: '/logout',
        icon: <FaIcons.FaSignOutAlt />,
        private: true,
    }
]